<script setup lang="ts">

    withDefaults(defineProps<{
        width?: number;
    }>(), { width: 20 });
</script>

<template>
    <svg
        :width="width"
        :height="width"
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.0547 10.5L14.0312 13.4766C14.1719 13.6172 14.2422 13.7969 14.2422 14.0156C14.2422 14.2188
        14.1719 14.3906 14.0312 14.5312C13.9531 14.6094 13.8672 14.6641 13.7734 14.6953C13.6797 14.7266 13.5859
        14.7422 13.4922 14.7422C13.3984 14.7422 13.3047 14.7266 13.2109 14.6953C13.1172 14.6641 13.0391 14.6094
        12.9766 14.5312L10 11.5547L7.02344 14.5312C6.94531 14.6094 6.85938 14.6641 6.76562 14.6953C6.6875 14.7266
        6.60156 14.7422 6.50781 14.7422C6.41406 14.7422 6.32031 14.7266 6.22656 14.6953C6.13281 14.6641 6.04688
        14.6094 5.96875 14.5312C5.82812 14.3906 5.75781 14.2188 5.75781 14.0156C5.75781 13.7969 5.82812 13.6172
        5.96875 13.4766L8.94531 10.5L5.96875 7.52344C5.82812 7.38281 5.75781 7.21094 5.75781 7.00781C5.75781
        6.78906 5.82812 6.60938 5.96875 6.46875C6.10938 6.32812 6.28125 6.25781 6.48438 6.25781C6.70312 6.25781
        6.88281 6.32812 7.02344 6.46875L10 9.44531L12.9766 6.46875C13.1172 6.32812 13.2891 6.25781 13.4922
        6.25781C13.7109 6.25781 13.8906 6.32812 14.0312 6.46875C14.1719 6.60938 14.2422 6.78906 14.2422
        7.00781C14.2422 7.21094 14.1719 7.38281 14.0312 7.52344L11.0547 10.5Z"
        />
    </svg>
</template>

